module.exports = __webpack_public_path__ + "static/knox-37cf3424f0178154e4932a876edf4753.jpg";